import React from 'react';
import {
  Box,
  Center,
  Heading,
  Text,
  Stack,
  Avatar,
  useColorModeValue,
  Image,
  HStack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

interface SmallProgramProps {
  id: string;
  name: string;
  description: string;
  tags: string;
  image?: string;
  slug?: string;
  organizationName?: string;
  organizationImage?: string;
}

export default function SmallProgram(props: SmallProgramProps) {
  const {
    id,
    name,
    image,
    description,
    organizationImage,
    slug,
    tags,
    organizationName,
  } = props;
  return (
    <Center height="max-content">
      <Link to={slug ? `/experience/${slug}` : `/info/${id}`}>
        <Box
          maxW="480px"
          minH="487px"
          w="full"
          boxShadow="md"
          rounded="md"
          p={6}
          overflow="hidden"
          transition="450ms cubic-bezier(.06,.71,.83,.67)"
          _hover={{
            cursor: 'pointer',
            transform: 'scale(1.03)',
            boxShadow: '2xl',
          }}
        >
          <Box
            h="210px"
            bg="gray.100"
            mt={-6}
            mx={-6}
            mb={6}
            pos="relative"
            overflow="hidden"
          >
            <Image src={image} layerStyle="contain" alt={name} />
          </Box>
          <Stack spacing={0} gap={6}>
            <Text
              as="h2"
              color="gray.700"
              fontSize="2xl"
              fontFamily="body"
              fontWeight={600}
              noOfLines={1}
            >
              {name}
            </Text>
            <Text color="gray.500" noOfLines={5}>
              {description}
            </Text>
          </Stack>
          <Stack
            mt={6}
            direction="row"
            height="48px"
            spacing={4}
            align="center"
          >
            <Image maxH="48px" src={organizationImage} alt={organizationName ?? ''} />
            <Stack direction="column" spacing={0} fontSize="sm"></Stack>
          </Stack>
        </Box>
      </Link>
    </Center>
  );
}
